import { render, staticRenderFns } from "./StatusReportHighPriceDetail.vue?vue&type=template&id=3a127076"
import script from "./StatusReportHighPriceDetail.vue?vue&type=script&lang=js"
export * from "./StatusReportHighPriceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports